import App from 'app'
import React from 'react'
import ReactDOM from 'react-dom/client'
import reportWebVitals from 'reportWebVitals'

import 'assets/styles/index.css'

// import { ErrorBoundary } from 'components/errors/error-boundary'

const root = ReactDOM.createRoot(document.getElementById('root'))
root.render(
  //<React.StrictMode>
    <App />
  //</React.StrictMode>
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
